export const environment = {
  production: true,
  LOGIN_URL: 'https://ftx-api.ffly.in/dtx_studio',
  CORE_URL: 'https://dtx-api.ffly.in',
  CORE_ADMIN_URL: 'https://ftx-admin.ffly.in',
  CORE_API_URL: 'https://ftx-api.ffly.in',
  FRONTEND_URL: 'https://dtx-studio.fitterfly.com/',
  name: 'production',
  is_test : false,
  /** Idle time before logout warning. */
  inactivityTimeoutMs: 60 * 60 * 1000,
};
